module.exports = __webpack_public_path__ + "img/76_PP_Aaron_Pastoriceasca_poslanie_Blaj_1760_foaie_de_titlu.ffb61b50.jpg";